<script>
  export let message = "Alert message"
  export let time = 3000
  export let status = "success"

  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  let display = "d-block"

  const showMessage = () => {
    setTimeout(() => {
      display = "d-none"
      dispatch("close")
    }, time)
  }

  showMessage()
</script>

<div class="alert alert-{status} {display}" role="alert">
  {message}
</div>
